export const API_PREFIX_POST_PATH = "/api/posts"
// Custom route tăng lượt xem dùng `post` số ít, khác prefix CRUD `/api/posts`.
export const API_POST_VIEW_PATH = "/api/post"
export const API_PREFIX_TAG_PATH = "/api/tags"
export const API_PREFIX_MEDIA_PATH = "/api/upload"
export const API_PREFIX_MEDIA_FOLDER_PATH = "/api/media"

export const API_PREFIX_BLOCK_CONTENT_PATH = "/api/block-contents"
export const API_PREFIX_CATEGORY_PATH = "/api/categories"
export const API_PREFIX_MENU_PREFERENCE_PATH = "/api/menu-preferences"

export const API_PREFIX_PAGE_PATH = "/api/pages"
// Custom singular route registered in api-cmstamda (routes/check-path.ts).
export const API_PAGE_CHECK_PATH = "/api/page/check-path"
export const API_PREFIX_SETTING_PATH = "/api/settings"
export const API_PREFIX_PRODUCT_PATH = "/api/products"
export const API_PREFIX_PRODUCT_CATEGORY_PATH = "/api/product-categories"
export const API_PREFIX_CONTACT_FORM_PATH = "/api/form-submits"
export const API_PREFIX_ORDER_PATH = "/api/orders"
export const API_PREFIX_ORDER_ITEMS_PATH = "/api/order-items"
export const API_PREFIX_PROMOTION_CODES_PATH = "/api/promotion-codes"
export const API_PREFIX_CUSTOMERS_PATH = "/api/customers"
export const API_PREFIX_MEMBERS_PATH = "/api/members"

export const API_PREFIX_USERS_PATH = "/api/users"
export const API_PREFIX_ROLES_PATH = "/api/users-permissions/roles"
export const API_PREFIX_DESTINATION_PATH = "/api/destinations"
export const API_PREFIX_TOUR_PATH = "/api/tour-v2s"

export const API_PREFIX_STATISTICS_PATH = "/api/website/stats"
export const API_PREFIX_WEBSITE_USERS_PATH = "/api/website/users"
export const API_PREFIX_LETAKY_PATH = "/api/letaks"
export const API_PREFIX_BANNER_PATH = "/api/banners"
export const API_PREFIX_WEBSITE_PATH = "/api/websites"
export const API_PREFIX_VIDEO_PATH = "/api/videos"
export const API_PREFIX_YOUTUBE_VIDEO_PATH = "/api/youtube-videos"
export const API_PREFIX_TAMDA_MEDIA_SETTING_PATH = "/api/tamda-media-eu-setting"
export const API_PREFIX_WEBSITE_EXPORT_PATH = "/api/website/export"
export const API_PREFIX_TAMDA_GROUP_SETTING_PATH = "/api/tamda-group-eu-setting"
export const API_PREFIX_STORES_PATH = "/api/stores"
export const API_PREFIX_EVENT_PATH = "/api/events"
export const API_PREFIX_CAREER_PATH = "/api/careers"
export const API_PREFIX_CAREER_FORMS_PATH = "/api/career-forms"
export const API_PREFIX_CAMPAIGN_SUBSCRIBERS_PATH = "/api/campaign-subscribers"
export const API_PREFIX_CAMPAIGNS_PATH = "/api/campaigns"
export const API_PREFIX_EVENT_SUBSCRIBERS_PATH = "/api/subscribers"
export const API_PREFIX_CONTACT_FORMS_PATH = "/api/contact-forms"
export const API_PREFIX_SUPPLIERS_PATH = "/api/suplliers"
export const API_PERMISSIONS_PATH = "/api/users-permissions/permissions"
export const API_REDIX_CACHE_PATH = "/api/redis-cache"
